module.exports = __webpack_public_path__ + "de77a722/img/share-action-icon.9c12578c.svg";